import React from "react";
import { injectIntl } from "react-intl";
import { Tab, Tabs } from "react-bootstrap";
import StatsGeneral from "./general/StatsGeneral";
import StatsE4coll from "./e4coll/StatsE4coll";
import StatsModal from "./StatsModal";
import StatsE4mad from "./e4mad/StatsE4mad";
import StatsE4vhp from "./e4vhp/StatsE4vhp";

class Stats extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };
  }

  dowloadFile(fileName, response) {
    let dataReceived = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(dataReceived);
    link.download = `${fileName}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onClickExport(fileName, onExport) {
    this.setState({
      modal: <StatsModal confirm={true} close={() => this.closeModal()} />,
    });

    const successCallback = (response) => {
      this.setState({ modal: null });
      this.dowloadFile(fileName, response);
    };

    onExport(successCallback);
  }

  closeModal() {
    this.setState({ modal: null });
  }

  openConfModal(fileName, onExport) {
    this.setState({
      modal: (
        <StatsModal
          confirm={false}
          successCallback={() => this.onClickExport(fileName, onExport)}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  render() {
    return (
      <>
        <Tabs defaultActiveKey="stats-general" id="statsTabs" mountOnEnter>
          <Tab
            eventKey="stats-general"
            title={this.props.intl.formatMessage({ id: "General.Indicators" })}
          >
            <StatsGeneral
              openConfModal={(fileName, onExport) =>
                this.openConfModal(fileName, onExport)
              }
            />
          </Tab>

          <Tab eventKey="stats-e4coll" title={"E4COLL"}>
            <StatsE4coll
              openConfModal={(fileName, onExport) =>
                this.openConfModal(fileName, onExport)
              }
            />
          </Tab>
          <Tab eventKey="stats-e4mad" title={"E4MAD"}>
            <StatsE4mad
              openConfModal={(fileName, onExport) =>
                this.openConfModal(fileName, onExport)
              }
            />
          </Tab>
          <Tab eventKey="stats-e4vhp" title={"E4VHP"}>
            <StatsE4vhp
              openConfModal={(fileName, onExport) =>
                this.openConfModal(fileName, onExport)
              }
            />
          </Tab>
        </Tabs>
        {this.state.modal}
      </>
    );
  }
}

export default injectIntl(Stats);
